import JSEncrypt from 'jsencrypt'
import {open} from "@/util";
import {message} from "ant-design-vue";

const publicKey = `MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEA8aPxsHkWQjrdSOmbhThU
eAABQAgu/VT5nkEaYZovVJamRO9+sSnUbsHhyOZNXeLuhBlbu4JXMF9LGbvUVTeI
nBbrT7rD4EHup2aA/C8836bS//VvghqdzUVppbxHfJ+uOejXITo3gtayTo48F0gh
GF0bocnkq9AVUnuCgdWJ5IMfAABlVfpqDRkm3Sht0IUDxmwOONvnw28NJZvQuo4k
3mCqYZLoxRHmBpBFqMeBVL/52wdq1xd94n/SUCB4EMAsYq5RblWRZlOct7dlssb2
kpNvweFag6Sf6lIvYxgqJZfLr6lwfQ3H4/M7YVeAH2ZHxKf5F64xjVUBx1spe8wL
ZwIDAQAB`
const publicKeyUrl = `MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEAgYa6+iAlzsnN6PJDVAdj
KzM7Uo1nM3HbdEylK5suqrq9MVE+NOKqp88SFmRfbt7lxyPfoTfbxUT2+JDhKHkf
euln0V6+4BTbqWwKpo+0lHOhg2VlKjZ5EZab5+vQw34uSZ7Bf7Pt8eMABn4Q+cd9
/VOTm10wCRFvL6JT3cm4qnHfsssTrAA0vOgG3qUn2XXEzLpxvsdP7se5MvAMdHxz
NiRZwaOTQ1a8O5VMrHYBl/vttws+TUEVAhW+ogi2uHH0ixKWKHxThlHSmxLB6Rg8
CWyfndkHo62CY00aKiWnOeokmQAwrWDcn4gsS10mQhCQi6ON7QcC5KF7W1k8h6yo
lQIDAQAB
`
const cuberUserStorage = JSON.parse(localStorage.getItem('cubeUser') || "{}")
const wxUserStorage = JSON.parse(localStorage.getItem('wxUser') || "{}")
const userStorage = JSON.parse(localStorage.getItem('user') || "{}")
export default {
    state: {
        user: userStorage,
        cubeUser: {
            sessionId: cuberUserStorage.sessionId || '',
            cubeAccountId: cuberUserStorage.cubeAccountId || '',
        },
        wxUser: {
            unionId: wxUserStorage.unionId || '',
        },
        zjerParam: {},
    },
    getters: {
        getUser(state) {
            return state.user
        },
        getZjerParam(state) {
            return state.zjerParam
        },
        getCubeUser(state) {
            return state.cubeUser
        },
        getWxUser(state) {
            return state.wxUser
        },
        getIsZjerTeacher(state) {
            return state.user.roles?.includes('teacher') && (!!state.user.personId || state.user.zsVerified)
        }
    },
    mutations: {
        setUser(state, user) {
            state.user = user
            localStorage.setItem('user', JSON.stringify(state.user))
        },
        setCubeUser(state, cubeUser) {
            if (Object.keys(cubeUser).length === 0) {
                state.cubeUser = {
                    sessionId: '',
                    cubeAccountId: '',
                }
            } else {
                Object.assign(state.cubeUser, cubeUser)
            }
            localStorage.setItem('cubeUser', JSON.stringify(state.cubeUser))
        },
        setWxUser(state, wxUser) {
            if (Object.keys(wxUser).length === 0) {
                state.wxUser = {
                    unionId: '',
                }
            } else {
                Object.assign(state.wxUser, wxUser)
            }
            localStorage.setItem('wxUser', JSON.stringify(state.wxUser))
        },
        setZjerParam(state, zjerParam) {
            state.zjerParam = zjerParam
        },
        setSessionId(state, sessionId) {
            state.sessionId = sessionId
        }
    },
    actions: {
        toClassServer({commit, state}, option = {}) {
            const user = state.user.userId ? state.user : (JSON.parse(localStorage.user || {}))
            if (!user.phone) {
                return void message.warning('请绑定手机号')
            }
            const encryptor = new JSEncrypt()
            let url = '', params = ''
            if (option.keyType === 'URL') {
                // 外研社
                encryptor.setPublicKey(publicKeyUrl) // 设置公钥
                url = option.redirectUrl, params = `${option.redirectUrl.indexOf('?') < 0 ? '?' : '&'}key=${btoa(encodeURI(encryptor.encrypt(JSON.stringify({
                    userId: user.userId,
                    userName: user.userName || '',
                    phone: user.phone || ''
                }))))}`
            } else {
                // 课后服务
                encryptor.setPublicKey(publicKey) // 设置公钥
                url = option.redirectUrl, params = `${option.redirectUrl.indexOf('?') < 0 ? '?' : '&'}key=${encodeURI(encryptor.encrypt(JSON.stringify({
                    userId: user.userId,
                    userName: user.userName || '',
                    phone: user.phone || ''
                })))}`
            }

            if (option.replace) {
                location.href = url + params
            } else {
                open((url.indexOf('http') < 0 ? 'https://' : '') + url + params, '_blank')
            }
            sessionStorage.removeItem('redirectUrl')
        }
    }
}
